import { render, staticRenderFns } from "./SearchResultsBrandCard.vue?vue&type=template&id=1ddc097e&scoped=true&"
import script from "./SearchResultsBrandCard.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsBrandCard.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsBrandCard.vue?vue&type=style&index=0&id=1ddc097e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc097e",
  null
  
)

export default component.exports